import { render, staticRenderFns } from "./c-booted-placeholder-loader.vue?vue&type=template&id=12f897db&scoped=true&"
import script from "./c-booted-placeholder-loader.vue?vue&type=script&lang=js&"
export * from "./c-booted-placeholder-loader.vue?vue&type=script&lang=js&"
import style0 from "./c-booted-placeholder-loader.vue?vue&type=style&index=0&id=12f897db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f897db",
  null
  
)

export default component.exports